import { useState } from "react";
import { message } from "antd";
import { ClientReportConfigs } from "../../../../../redux/models/clientReportConfigs";
import { EditConfigModal } from "./editConfigModal";
import { EditIconButton } from "../../../../../common/components/iconButton/editIconButton";

export const EditConfigButton = ({ configuration, clients, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const availableClients = clients.map((c) => ({ label: c.name, value: c.id }));

  const onFinish = async (values) => {
    const { clientId, ...data } = values;

    try {
      setLoading(true);
      const res = await ClientReportConfigs.update(clientId, data, false);

      onSuccess(res.data);
      setOpen(false);
      message.success("Reports configuration successfully updated");
    } catch (e) {
      message.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <EditIconButton disabled={loading} onClick={() => setOpen(true)}>
        Edit
      </EditIconButton>
      {open && (
        <EditConfigModal
          open={open}
          onCancel={() => setOpen(false)}
          loading={loading}
          onFinish={onFinish}
          availableClients={availableClients}
          configuration={configuration}
        />
      )}
    </>
  );
};
